import { Camera } from '@capacitor/camera';
import { Capacitor } from '@capacitor/core';
import { useEffect, useState } from 'react';
import { telemetry } from '../../services/backend';

const useCheckImagesPermissions = () => {
  const [showPermissionMessage, setShowPermissionMessage] = useState(false);
  const [reEvaluatePermissions, setReEvaluatePermissions] = useState(false);

  const showPermissionDisclaimerIfNeed = async () => {
    const showCameraAvailable =
      Capacitor.isNativePlatform() && Capacitor.isPluginAvailable('Camera');
    const newCameraPermission = await Camera.checkPermissions();
    const showPermissionMessageValue =
      showCameraAvailable &&
      (!['granted', 'limited'].includes(newCameraPermission.camera) ||
        !['granted', 'limited'].includes(newCameraPermission.photos));
    setShowPermissionMessage(showPermissionMessageValue);
  };

  useEffect(() => {
    const checkPermissions = async () => {
      const makeCameraServiceRequest = async () => {
        try {
          // Make the request to enable Camera/photo permissions
          if (!Capacitor.isNativePlatform()) return;

          const cameraPermission = await Camera.checkPermissions();
          if (!['granted', 'limited'].includes(cameraPermission.camera)) {
            await Camera.requestPermissions({
              permissions: ['camera'],
            });
            setReEvaluatePermissions(true);
          } else if (
            !['granted', 'limited'].includes(cameraPermission.photos)
          ) {
            await Camera.requestPermissions({
              permissions: ['photos'],
            });
            setReEvaluatePermissions(true);
          }
        } catch (error) {
          telemetry(
            telemetry.ERROR,
            `[cameraPermissions] received error of ${JSON.stringify(error)}`,
          );
        }
      };
      await showPermissionDisclaimerIfNeed();
      if (showPermissionMessage || reEvaluatePermissions) {
        await makeCameraServiceRequest();
      }
    };

    checkPermissions();
  }, [reEvaluatePermissions, showPermissionMessage]);

  return { showPermissionMessage, setReEvaluatePermissions };
};

export default useCheckImagesPermissions;
